import { flatten } from 'lodash';

export const array = <T>(
  ...a: Array<Array<T> | T | undefined | false | null>
): Array<T> => flatten(a).filter(Boolean) as T[];
